import React from 'react';
import PropTypes from 'prop-types';
import { Recommendations, RecommendationSliders } from '@xp-utilities/web';
import MiniBagRecommendationsContextProvider from '../../context/Recommendations/MiniBagRecommendationsContextProvider';
import useDigitalData from '../../hooks/useDigitalData';
import handleOnProductClick from './helpers';

export const INSTANCE_DATA_ATTRIBUTE = 'data-recommendations-client';

export default function MiniBagInstrumentedRecommendations({ id, placements, miniBagData }) {
  const { getDigitalDataValue } = useDigitalData();
  const useRecommendationSliders = getDigitalDataValue('chk-mini-bag-recs');

  return (
    <MiniBagRecommendationsContextProvider id={id} data={miniBagData}>
      <div
        id={id}
        data-testid={id}
      >
        {useRecommendationSliders ? (
          <RecommendationSliders
            placements={placements}
            slidesToShow={2} // Default value, can be made configurable if needed
            onProductClick={(event, product = {}) => {
              handleOnProductClick(event, product);
            }}
          />
        ) : (
          <Recommendations placements={placements} />
        )}
      </div>
    </MiniBagRecommendationsContextProvider>
  );
}

MiniBagInstrumentedRecommendations.propTypes = {
  id: PropTypes.string.isRequired,
  placements: PropTypes.arrayOf(PropTypes.string),
  miniBagData: PropTypes.shape({}).isRequired,
};
MiniBagInstrumentedRecommendations.defaultProps = { placements: [] };
